import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import React from "react";
// import ProtectedRoute from "./ProtectedRoute";
import moment from "moment";
import $ from "jquery";

import Cookies from "js-cookie";

import PageNotFound from "./components/common/PageNotFound";
import AuthLogin from "./components/common/AuthLogin";
import Home from "./components/Home/Home";

//const token = Cookies.get("AuthToken");

function App() {
  const auth = () => {
    if (Cookies.get("AuthToken")) {
      return true;
    } else {
      return false;
    }
  };

  const body = document.querySelector("body");
  body?.style.setProperty("--screen-height", $(window).height() + "px");

  const isAuthenticated = auth();

  return (
    <div className="App">
      <Router>
        <Routes>
          {/* <Route exact path="/" component={Home} /> */}

          <Route exact path="/Home/:surveyId" element={<Home />} />
          <Route
            exact
            path="/:companyName/Analytics/:surveyId"
            element={<Home />}
          />

          {/* <ProtectedRoute exact path="/Dashboard" component={Dashboard} isAuth={isAuthenticated} />
            <ProtectedRoute
              exact
              path="/EditOrganization/:orgId"
              component={EditOrganization}
              isAuth={isAuthenticated}
            /> */}
          <Route
            exact
            path="/:companyName/AnalyticsRequest/:surveyId"
            element={<AuthLogin />}
          />
          <Route
            exact
            path="/:companyName/Login/:surveyId"
            element={<AuthLogin />}
          />
          <Route element={<AuthLogin />} />

          <Route exact path="/PageNotFound" element={<PageNotFound />} />
          <Route element={<PageNotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
